import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/dashboard' },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Login.vue'),
      meta: { guest: true }
    },
    {
      path: '/dashboard',
      component: () => import('../views/Layout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'Dashboard',
          component: () => import('../views/Dashboard.vue')
        },
        // 教师端
        {
          path: 'classes',
          name: 'Classes',
          component: () => import('../views/teacher/Classes.vue'),
          meta: { roles: ['teacher', 'admin'] }
        },
        {
          path: 'students',
          name: 'Students',
          component: () => import('../views/teacher/Students.vue'),
          meta: { roles: ['teacher', 'admin'] }
        },
        {
          path: 'contents',
          name: 'Contents',
          component: () => import('../views/teacher/Contents.vue'),
          meta: { roles: ['teacher', 'admin'] }
        },
        {
          path: 'recitation-check',
          name: 'RecitationCheck',
          component: () => import('../views/teacher/RecitationCheck.vue'),
          meta: { roles: ['teacher', 'admin'] }
        },
        {
          path: 'records',
          name: 'Records',
          component: () => import('../views/teacher/RecordList.vue'),
          meta: { roles: ['teacher', 'admin'] }
        },
        {
          path: 'api-settings',
          name: 'ApiSettings',
          component: () => import('../views/teacher/ApiSettings.vue'),
          meta: { roles: ['teacher', 'admin'] }
        },
        // 学生端
        {
          path: 'my-records',
          name: 'MyRecords',
          component: () => import('../views/student/MyRecords.vue'),
          meta: { roles: ['student'] }
        },
        {
          path: 'leaderboard',
          name: 'Leaderboard',
          component: () => import('../views/Leaderboard.vue')
        },
        // 管理员
        {
          path: 'admin-users',
          name: 'AdminUsers',
          component: () => import('../views/admin/UserManage.vue'),
          meta: { roles: ['admin'] }
        },
        {
          path: 'admin-contents',
          name: 'AdminContents',
          component: () => import('../views/admin/ContentManage.vue'),
          meta: { roles: ['admin'] }
        },
        {
          path: 'profile',
          name: 'Profile',
          component: () => import('../views/Profile.vue')
        }
      ]
    },
    { path: '*', redirect: '/dashboard' }
  ]
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!store.state.token
  if (to.meta.requiresAuth && !isLoggedIn) {
    return next('/login')
  }
  if (to.meta.guest && isLoggedIn) {
    return next('/dashboard')
  }
  if (to.meta.roles && isLoggedIn) {
    const userRole = store.state.user && store.state.user.role
    if (!to.meta.roles.includes(userRole)) {
      return next('/dashboard')
    }
  }
  next()
})

export default router
